import { push } from 'react-router-redux';

import InvitationApi from 'Api/invitation';
import { clearAutocomplete as clearJournalAutocomplete } from './journal';
import { LOGIN_SUCCESS, REGISTER_DATA_SUCCESS } from 'Actions/auth';

// invitation list
export const INVITATION_LIST_REQUEST = 'INVITATION_LIST_REQUEST';
export const INVITATION_LIST_SUCCESS = 'INVITATION_LIST_SUCCESS';
export const INVITATION_LIST_ERROR = 'INVITATION_LIST_ERROR';
export const INVITATION_LIST_UPDATE_FILTER = 'INVITATION_LIST_UPDATE_FILTER';


//invitation update
export const INVITATION_STORE_REQUEST = 'INVITATION_STORE_REQUEST';
export const INVITATION_STORE_SUCCESS = 'INVITATION_STORE_SUCCESS';
export const INVITATION_STORE_ERROR = 'INVITATION_STORE_ERROR';

//invitation agree
export const INVITATION_NAME_AUTOCOMPLETE_REQUEST = 'INVITATION_NAME_AUTOCOMPLETE_REQUEST';
export const INVITATION_NAME_AUTOCOMPLETE_SUCCESS = 'INVITATION_NAME_AUTOCOMPLETE_SUCCESS';
export const INVITATION_NAME_AUTOCOMPLETE_ERROR = 'INVITATION_NAME_AUTOCOMPLETE_ERROR';

export const INVITATION_NAME_AUTOCOMPLETE_CLEAR = 'INVITATION_NAME_AUTOCOMPLETE_CLEAR';

/**
 * Store invitation
 *
 * @param data
 * @returns {{requestType: string, request: (function(*))}}
 */
export function storeInvitation(data) {
    return {
        requestType: 'INVITATION_STORE',
        request: InvitationApi.storeInvitation(data),
        success: (response, dispatch) => {
            dispatch(clearJournalAutocomplete());

            return {
                payload: response,
            };
        },
    };
}

/**
 * Load all instances of the model matched by filters from the data source
 *
 * @param filter
 * @returns {Object}
 */
export function loadInvitations(filter = {}) {
    return {
        requestType: 'INVITATION_LIST',
        request: InvitationApi.find(filter),
    };
}

/**
 * Load all instances of the model matched by filters from the data source
 *
 * @param filter
 * @returns {Object}
 */
export function loadNameAutocomplete(filter = {}) {
    return {
        requestType: 'INVITATION_NAME_AUTOCOMPLETE',
        request: InvitationApi.find(filter),
    };
}

/**
 * Update filter
 *
 * @param {Object} filter
 *
 * @return {Object}
 */
export function updateFilter(filter = {}) {
    return {
        type: INVITATION_LIST_UPDATE_FILTER,
        payload: filter,
    };
}

/**
 * Invitation agree action
 *
 * @param token
 * @returns {Object}
 */
export function agreeInvitation(token) {
    return {
        requestType: 'INVITATION_AGREE',
        request: InvitationApi.agreeInvitation(token),
        success: (response, dispatch) => {
            if(response.data && 'invitation' in response.data) {
                const data = response.data;
                if('user' in data) {
                    dispatch({ type: LOGIN_SUCCESS, payload: data.invitation });
                    if (data.invitation.reviewer) {
                        dispatch(push(`/submissions/${data.invitation.reviewer.submission_id}`));
                    } else {
                        dispatch(push('/login'));
                    }
                } else {
                    dispatch({ type: REGISTER_DATA_SUCCESS, payload: data.invitation });
                }
            }

            return {
                payload: response
            };
        },
    };
}

/**
 * Invitation disagree action
 *
 * @param token
 * @returns {Object}
 */
export function disagreeInvitation(token) {
    return {
        requestType: 'INVITATION_DISAGREE',
        request: InvitationApi.disagreeInvitation(token),
    };
}



// WEBPACK FOOTER //
// ./src/actions/invitation.js